import { useLocation, useNavigate, useParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { API_BASE_URL, DEFAULT_PAGE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "../../utilities/constants";
import PaginatedDropdown, { mapOptions } from "../../components/ui/PaginatedDropDown";
import MultiDropdown from "../../components/common/MultiDropdown";
import { useEffect, useState } from "react";
import { dobToAge, formatHeightUnit, handleApiCall } from "../../utilities/helper";
import { useUI } from "../../context/UI";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Spinner from "../../components/ui/Spinner";

const LookGeneration = () => {
    const [selectedStylist, setselectedStylist] = useState(null);
    const [selectedVibe, setSelectedVibe] = useState(null);
    const [isVibeDropdownMode, setIsVibeDropdownMode] = useState(false);
    const location = useLocation();
    const { id } = useParams();
    const [data, setData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lookLoading, setLookLoading] = useState(false);
    const navigate = useNavigate();
    const [controller, setController] = useState(null);
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    console.log("selectedSTYLISTTT", selectedStylist?.label);

    const labelStylistFunc = (o) => `${o.displayName}`;

    const initialValues = {
        // style: "",
        stylistId: "",
        vibe: "",
    }
    const validationSchema = Yup.object().shape({
        stylistId: Yup.string().required("Stylist is required"),
        vibe: Yup.string().required("Vibe is required"),
        // style: Yup.string().required("Style is required"),
    });

    const dropdownSources = [
        {
            id: "events",
            label: "Events",
            url: `${API_BASE_URL}/api/1.0.0/aimatchedstyle/all-categories?`,
            datakey: "",
            searchkey: "keyword",
            mapOptions: (records) => mapOptions(records, "id", (o) => `${o.displayName}`),
        },
        {
            id: "vibes",
            label: "Vibes",
            url: `${API_BASE_URL}/api/1.0.0/vibecheck/vibe-questions-choices?`,
            datakey: "data",
            searchkey: "keyword",
            mapOptions: (data) => {
                const choices = data?.[0]?.choices || [];
                return choices.map(c => ({ value: c.id, label: c.choiceText }));
            },
        },
    ];


    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/customer/v2/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
                return true;
            } else {
                setData(null);
                // return false;
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
    }, [location.search]);

    const handleLookGeneration = async () => {
        setLookLoading(true);
        const age = dobToAge(data?.profile?.profile?.dob);
        try {
            const payload = {
                stylistId: selectedStylist?.value || "",
                vibe: selectedVibe?.label ? selectedVibe?.label : selectedVibe,
                age: age || 26,
                height: data?.profile?.profile?.height,
                weight: data?.profile?.profile?.weight,
                gender: data?.profile?.profile?.gender,
                requestBy: "system",
                // location:"US",
                // style: selectedCategory?.label || "",
            };

            console.log("Payload before API call:", JSON.stringify(payload, null, 2));

            // Step 1: Call enqueue API  ${data?.profile?.id}
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/aigenlook/v3/enqueue/30`,
                {
                    method: "POST",
                    body: payload,
                }
            );

            if (response?.data?.jobId) {
                const jobId = response.data.jobId;
                console.log("Job started with ID:", jobId);

                // Step 2: Poll status API until job completes
                const pollInterval = 5000; // 5 seconds
                const maxAttempts = 30;

                let attempts = 0;
                let jobStatus = response.data.status;

                while (jobStatus === "PENDING" && attempts < maxAttempts) {
                    await new Promise((resolve) => setTimeout(resolve, pollInterval));
                    const statusResponse = await handleApiCall(
                        `${API_BASE_URL}/api/1.0.0/aigenlook/v2/look-job/${jobId}`,
                        { method: "GET" }
                    );

                    jobStatus = statusResponse?.data?.status;
                    console.log(`Job ${jobId} status:`, jobStatus);
                    attempts++;
                }

                // Step 3: When completed, navigate
                if (jobStatus === "READY") {
                    addToastMessage({
                        status: true,
                        message: "Looks successfully generated!",
                    });
                    setNewNotification(true);
                    addNotification({
                        id: Date.now(),
                        message: "Looks generation completed successfully!",
                        status: true,
                        archive: false,
                    });

                    // Navigate to look-details and pass jobId + profile
                    navigate(`/look-details/${data?.profile?.id}`, {
                        state: { jobId, profile: data, stylist:selectedStylist },
                    });
                } else if (jobStatus === "FAILED") {
                    addToastMessage({
                        status: "success",
                        message: "Looks generation failed. Please try again.",
                    });
                } else {
                    addToastMessage({
                        status: "warning",
                        message:
                            "Looks generation is taking too long. Please check again later.",
                    });
                }
            } else {
                addToastMessage({
                    status: "warning",
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating looks. Please try again!",
                });
            }
        } catch (e) {
            console.error("Look generation error:", e);
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while generating looks.",
                status: "error",
                archive: false,
            });
        } finally {
            setLookLoading(false);
        }
    };

    return (
        <>
            <PageMeta
                title={`Look Generation - ${DEFAULT_PAGE_TITLE}`}
                description={`Look Generation - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Look Generation"
                    breadcrumbs={[
                        { label: "Customer", path: "/customers" },
                        { label: "customers Details", path: `/customers-details/${data?.profile?.id}` },
                        { label: "Look Details", path: `/look-details/${data?.profile?.id}` },
                        { label: "Look Generation" },
                    ]}
                />
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl mb-">
                    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6">
                        <img
                            src={
                                data?.profile?.profile?.profileDpSignedUrl
                                    ? data.profile?.profile?.profileDpSignedUrl
                                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        `${data?.profile?.firstName || ""} ${data?.profile?.lastName || ""}`
                                    )}&background=a8936a&color=fff`
                            }
                            // src={data?.profile?.profile?.profileDpSignedUrl}
                            alt={`${data?.profile?.firstName} ${data?.profile?.lastName}`}
                            className="w-28 h-28 rounded-full object-cover border-2 border-gray-300 dark:border-gray-700"
                        />

                        <div className="flex-1">
                            <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-1">
                                {`${data?.profile?.firstName || ""} ${data?.profile?.lastName || ""}`}
                            </h2>
                            <p className="text-gray-600 dark:text-gray-300 mb-2">
                                {data?.profile?.email || "No email provided"}
                            </p>

                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
                                <div>
                                    <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Age</p>
                                    <p className="font-medium text-gray-800 dark:text-gray-100">{dobToAge(data?.profile?.profile?.dob) || 0} <span className="text-sm font-normal">YEARS</span></p>
                                </div>
                                <div>
                                    <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Gender</p>
                                    <p className="font-medium text-gray-800 dark:text-gray-100 capitalize">{data?.profile?.profile?.gender || "-"}</p>
                                </div>
                                <div>
                                    <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Height</p>
                                    <p className="font-medium text-gray-800 dark:text-gray-100">{data?.profile?.profile?.height || 0} <span className="text-sm font-normal">{formatHeightUnit(data?.profile?.profile?.heightUnit) || "CM"}</span></p>
                                </div>
                                <div>
                                    <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Weight</p>
                                    <p className="font-medium text-gray-800 dark:text-gray-100">{data?.profile?.profile?.weight || 0} <span className="text-sm font-normal">{data?.profile?.profile?.weightUnit || "KG"}</span></p>
                                </div>
                                <div>
                                    <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Shoe Size</p>
                                    <p className="font-medium text-gray-800 dark:text-gray-100">{data?.profile?.profile?.shoeSize || 0} <span className="text-sm font-normal">{data?.profile?.profile?.shoeSizeUnit || "CM"}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleLookGeneration}
            >
                {({ values, errors, touched, setTouched, setFieldValue }) => (
                    <Form>
                        <div className="bg-gray-50 dark:bg-gray-900 rounded-xl mt-5 ">
                            <h3 className="text-lg font-semibold text-brand-600 mb-3">Generate Look</h3>

                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        Stylist
                                    </label>
                                    <PaginatedDropdown
                                        searchkey="search"
                                        datakey="data"
                                        url={`${API_BASE_URL}/api/1.0.0/aistylist/v2/stylists?type=VIRTUAL&`}
                                        mapOptions={(records) =>
                                            mapOptions(records, "id", labelStylistFunc)
                                        }
                                        selectedValue={selectedStylist}
                                        placeHolder="Search"
                                        error={errors.stylistId && touched.stylistId ? errors.stylistId : ""}
                                        onChange={(value) => {
                                            setselectedStylist(value);
                                            setFieldValue("stylistId", value?.value || "");
                                        }}
                                    />

                                </div>
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                            Vibe
                                        </label>
                                        <button
                                            type="button"
                                            onClick={() => setIsVibeDropdownMode(!isVibeDropdownMode)}
                                            className="text-xs text-brand-600 dark:text-brand-400 hover:underline focus:outline-none"
                                        >
                                            {isVibeDropdownMode ? "Switch to Manual Input" : "Select from List"}
                                        </button>
                                    </div>
                                    {isVibeDropdownMode ? (
                                        <MultiDropdown
                                            sources={dropdownSources}
                                            selectedValue={
                                                selectedVibe?.label
                                                    ? selectedVibe
                                                    : selectedVibe
                                                        ? { label: selectedVibe, value: selectedVibe }
                                                        : null
                                            }
                                            placeHolder="Select Vibe"
                                            error={touched.vibe && errors.vibe ? errors.vibe : ""}
                                            onChange={(v) => {
                                                setSelectedVibe(v);
                                                setFieldValue("vibe", v?.label || "");
                                            }}
                                        />
                                    ) : (
                                        <>
                                            <input
                                                type="text"
                                                name="vibe"
                                                value={selectedVibe?.label ? selectedVibe.label : selectedVibe || ""}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    setSelectedVibe(val);
                                                    setFieldValue("vibe", val);
                                                }}
                                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-500 focus:border-brand-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand-500 dark:focus:border-brand-500 ${touched.vibe && errors.vibe ? "border-red-500" : ""
                                                    }`}
                                                placeholder="e.g. old money / work"
                                            />
                                            {touched.vibe && errors.vibe && (
                                                <p className="mt-1 text-xs text-red-500">{errors.vibe}</p>
                                            )}
                                        </>
                                    )}

                                </div>
                                {/* 
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        Preferred Style
                                    </label>
                                    <PaginatedDropdown
                                        searchkey="search"
                                        datakey="data"
                                        url={`${API_BASE_URL}/api/1.0.0/aimatchedstyle/all-categories?`}
                                        mapOptions={(records) =>
                                            mapOptions(records, "id", labelCategoryFunc)
                                        }
                                        error={errors.style && touched.style ? errors.style : ""}
                                        selectedValue={selectedCategory}
                                        placeHolder="Search"
                                        onChange={(value) => {
                                            setSelectedCategory(value); // your UI state
                                            setFieldValue("style", value?.value || "");
                                        }}
                                    // onChange={(value) => setSelectedCategory("style", value)}
                                    />
                                </div> */}
                            </div>

                            <div className="mt-5 flex justify-end">
                                <button
                                    type="Submit"
                                    disabled={lookLoading}
                                    className={`flex items-center justify-center gap-2 px-6 py-2 rounded-md text-white transition ${lookLoading
                                        ? "bg-brand-400 cursor-not-allowed opacity-80"
                                        : "bg-brand-600 hover:bg-brand-700"
                                        }`}
                                >
                                    {lookLoading ? (
                                        <>
                                            <svg
                                                className="animate-spin h-4 w-4 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                ></path>
                                            </svg>
                                            Generating...
                                        </>
                                    ) : (
                                        "Generate Look"
                                    )}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>

        </>
    );

}
export default LookGeneration;